module.exports = __webpack_public_path__ + "img/group_businessman-256.54f3dbb8.png";